import React, { Fragment, useCallback, useEffect, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { useVirtual } from "react-virtual";

import get from "lodash/get";
import size from "lodash/size";

import DayEntry from "./DayEntry";

import { DayGroupsShape, EntriesShape } from "../../props";

export default function DayEntries(props) {
  const parentRef = useRef();

  const dayCacheRef = useRef(null);

  const { dayGroups: days, fetchEntries, hasMore, loading } = props;

  const dayCount = days.length;

  useEffect(function cacheDays() {
    const newCache = days.map(function({ key, entries }) {
      return { key, size: size(entries) };
    });

    dayCacheRef.current = newCache;
  }, [days]);

  const estimateSize = useCallback(function(index) {
    const size = get(dayCacheRef, ["current", index, "size"], 1);

    return size * 96;
  }, []);

  const keyExtractor = useCallback(function(index) {
    return get(dayCacheRef, ["current", index, "key"], index);
  }, []);

  const virtualizer = useVirtual({
    overscan: 50,
    size: dayCount,
    parentRef,
    estimateSize,
    keyExtractor,
  });

  const {
    onClone, onCreate, onDelete, onEdit, onSubmit,
    selected, setSubmitGroupEnabled
  } = props;

  return (
    <div className="history-list-entries" ref={parentRef}>
      <div style={{ height: virtualizer.totalSize, width: "100%", position: "relative" }}>
        {virtualizer.virtualItems.map((virtualRow) => {
          const day = days[virtualRow.index];

          if (!day) {
            return null;
          }

          return (
            <DayEntry
              key={virtualRow.index}
              measureRef={virtualRow.measureRef}
              day={day}
              entries={day.entries}
              isWorkDay={day.isWorkDay}
              onClone={onClone}
              onCreate={onCreate}
              onDelete={onDelete}
              onEdit={onEdit}
              onSubmit={onSubmit}
              selected={selected}
              setSubmitGroupEnabled={setSubmitGroupEnabled}
              workDay={day.workDay}
            />
          );
        })}
      </div>
    </div>
  );
}

DayEntries.displayName = "History.DayEntries";

DayEntries.propTypes = {
  dayGroups: DayGroupsShape,
  fetchEntries: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  onClone: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  selected: PropTypes.object,
  setSubmitGroupEnabled: PropTypes.func.isRequired,
};

DayEntries.defaultProps = {
  hasMore: false,
  loading: true,
};



// WEBPACK FOOTER //
// ./app/components/History/DayEntries.jsx